export const filterForPaymentLinkSchema = [
    {
        id: "context.legalEntity.code",
        label: "Business Unit",
        type: "text",
        multiselector: true,
        displayLogo: false,
        showTitleType: false,
        filterTitle: true,
        uniqueType: false,
        items: ["data from api"],
    },
    {
        id: "timestamp",
        label: "Created At",
        type: "date",
        multiselector: false,
        displayLogo: false,
        showTitleType: false,
        uniqueType: false,
        items: [],
    },
    {
        id: "userId",
        label: "Created By",
        type: "text",
        multiselector: true,
        displayLogo: false,
        showTitleType: false,
        filterTitle: true,
        uniqueType: false,
        items: ["data from api"],
    },
    {
        id: "status",
        label: "Status",
        type: "text",
        multiselector: true,
        displayLogo: false,
        showTitleType: false,
        filterTitle: true,
        uniqueType: false,
        items: ["data from api"],
    },
];
